import { useCallback, useState } from "react"

const defaultCookieConfig = {
  domain: window.location.host,
  "max-age": 60 * 60 * 24 * 30,
  path: "/",
}
const cookieConfigString = Object.entries(defaultCookieConfig)
  .map(([key, value]) => `${key}=${value}`)
  .join("; ")

function readCookie(name) {
  if (typeof document === "undefined") return null

  const cookies = document.cookie.split(";").map((c) => c.trim())

  const cookie = cookies.find((c) => c.startsWith(`${name}=`))

  return cookie && decodeURIComponent(cookie.split("=")[1])
}

export function useCookie(name) {
  const [cookieState, setCookieState] = useState(() => readCookie(name))
  const update = useCallback(
    (newValue) => {
      document.cookie = `${name}=${encodeURIComponent(
        newValue,
      )}; ${cookieConfigString}`
      setCookieState(newValue)
    },
    [name],
  )

  return [cookieState, update]
}
